import React, { Component } from 'react';
import { withStyles } from '@material-ui/core';
import classnames from 'classnames';
import combineStyles from '../../../helpers/combineStyles';
import LayoutStyles from '../../../styles/layout';
import ButtonStyles from '../../../styles/button';
import TypographyStyles from '../../../styles/typography';
import SpacingStyles from '../../../styles/helpers/spacing';
import ListsStyle from '../__styles__/Lists.style';
import Table from '../../shared/Table/Table';
import { columns, mapData } from './TableMetaData';
import { DEFAULT_ROWS_PER_PAGE } from '../../../constants/request_constants';
import parseQuerystring from '../../../helpers/parseQuerystring';
import PermissionsFilter from './PermissionsFilter';

class PermissionPage extends Component {
  state = {
    rowsPerPage:
      Number(sessionStorage.getItem('BrillaRowsPerPage')) ||
      DEFAULT_ROWS_PER_PAGE
  };

  componentDidMount() {
    this._fetchItems();
  }

  _fetchItems = params => {
    const query = params || parseQuerystring(this.props) || {};
    this.props.fetchPermissions({
      ...query,
      page: query.page || 1,
      perPage: this.state.rowsPerPage
    });
  };

  _handleChangePage = page => {
    const query = parseQuerystring(this.props) || {};
    this._fetchItems({
      ...query,
      page: page + 1
    });
  };

  _handleChangeRowsPerPage = rowsPerPage => {
    sessionStorage.setItem('BrillaRowsPerPage', rowsPerPage);
    this.setState({ rowsPerPage: rowsPerPage, page: 1 }, this._fetchItems);
  };

  _handleRowClick = item => {
    this.props.history.push(`/permissions/${item.id}`);
  };

  render() {
    const {
      classes,
      permissions,
      requestPermissionsAdminSend,
      meta
    } = this.props;
    const { page } = parseQuerystring(this.props) || {};

    return (
      <div>
        <div className={classes.titleRootWrapper}>
          <h1 className={classnames(classes.headline4, classes.title)}>
            {'Permisos'}
          </h1>
        </div>
        <div>
          <div className={classes.filterOptionsWrapper}>
            <PermissionsFilter onChangeFilter={this._fetchItems} />
          </div>
        </div>
        <div>
          <Table
            name={'Permisos'}
            columns={columns}
            data={mapData(permissions)}
            onChangePage={this._handleChangePage}
            onChangePageRowsPerPage={this._handleChangeRowsPerPage}
            page={page - 1}
            rowsPerPage={this.state.rowsPerPage}
            totalCount={permissions.length}
            nextPage={meta.nextPage}
            withNoCountPagination={true}
            onClickOnRow={props => {
              this._handleRowClick(props);
            }}
            loading={requestPermissionsAdminSend}
          />
        </div>
      </div>
    );
  }
}

export default withStyles(
  combineStyles(
    LayoutStyles,
    ButtonStyles,
    TypographyStyles,
    SpacingStyles,
    ListsStyle,
    { withTheme: true }
  )
)(PermissionPage);
